import C from 'actionTypes'

export const goDocumentsSubSection = documentListType => ({
  type: C.CLIENT_DOCUMENTS,
  payload: {
    documentListType
  }
})

export const goProfileSubSection = profileType => ({
  type: C.CLIENT_PROFILE_SETTINGS,
  payload: {
    profileType
  }
})

export default {
  goDocumentsSubSection,
  goProfileSubSection
}



// WEBPACK FOOTER //
// ./src/actions/client/routing.js